type FlatMessages = Record<string, string>;

/**
 * `react-intl` consumes a flat `{ "a.b.c": "string" }` map keyed by dotted
 * paths. The shared `@immo/i18n` dictionary is nested ({@link de}/{@link en}
 * are deep object trees). Flatten once at boot.
 */
export function flattenMessages(input: unknown, prefix = ''): FlatMessages {
  const out: FlatMessages = {};

  if (input === null || typeof input !== 'object') return out;

  for (const [key, value] of Object.entries(input)) {
    const path = prefix ? `${prefix}.${key}` : key;

    if (typeof value === 'string') {
      out[path] = value;
    } else if (typeof value === 'object' && value !== null) {
      Object.assign(out, flattenMessages(value, path));
    }
  }

  return out;
}
